import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Categories from '../components/Categories';

const Products = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <Categories />
      </main>
      <Footer />
    </div>
  );
};

export default Products;

